<template>
  <div class="appointment-notice">
    <div class="notice-content">
      <p class="body20-light" v-html="noticeText"></p>
    </div>

    <div class="notice-action">
      <button class="btn-understand primary-cta" @click="acceptNotice">
        {{ $t('notices.understand') }}
        <img :src="checkmarkIcon" alt="Icona">
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import checkmarkIcon from '@/assets/images/check-white-icon.svg';

export default {
  name: 'AppointmentNotice',
  data () {
    return {
      checkmarkIcon,
    };
  },
  props: {
    notice: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('appointment', ['getNoticeText']),

    noticeText () {
      // Se è fornita una chiave di traduzione, usa il getter dello store
      if (this.notice.textKey) {
        // Estrai l'ultima parte della chiave (es. da 'notices.availability' a 'availability')
        const noticeKey = this.notice.textKey.split('.').pop();
        return this.getNoticeText(noticeKey);
      }

      // Altrimenti usa il testo diretto (per retrocompatibilità)
      return this.notice.text || '';
    }
  },

  methods: {
    acceptNotice () {
      this.$emit('accept-notice');
      this.$emit('proceed-next');
    }
  }
};
</script>